import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FM010 {
  fm010_01: string;        // 類別代號 (PK)
  fm010_11: string;        // 名稱
  fm010_12: string;        // 庫存 +/-
  fm010_21: number;        // 允許異動比率 (0~100)
  fm010_91: string;        // 建立人員代號
  fm010_92: string | null; // 建立/修改日期
  fm010_93: string;        // 修改人員代號
}

export interface CreateRequest {
  fm010_01: string;
  fm010_11: string;
  fm010_12: string;
  fm010_21: number;
}

export interface UpdateRequest {
  fm010_11: string;
  fm010_12: string;
  fm010_21: number;
}

export interface CopyRequest {
  new_code: string;
  from_code: string;
}

export interface ListResponse {
  data: FM010[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const invMoveCatApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/inv-move-cat', { params });
    return res.data;
  },

  async get(code: string): Promise<FM010> {
    const res = await apiClient.get(`/api/inv-move-cat/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FM010> {
    const res = await apiClient.post('/api/inv-move-cat', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FM010> {
    const res = await apiClient.put(`/api/inv-move-cat/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async copy(data: CopyRequest): Promise<FM010> {
    const res = await apiClient.post('/api/inv-move-cat/copy', data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/inv-move-cat/${encodeURIComponent(code)}`);
  },
};
